var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-breadcrumb',{staticClass:"mb-6",attrs:{"items":[
   {
     title: '营销中心',
     url: '/sales/coupon'
   },
   {
     title: '优惠券',
     active: true
   }
 ]}}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }